import About from "../About/About";
import ImgProfil from "../ImgProfil/ImgProfil";
import ContactMe from "../ContactMe/ContactMe";

function Card() {
  return (
    <div className="banners">
      <div>
        <ContactMe />
      </div>
      <div>
        <About />
      </div>

      <ImgProfil />
    </div>
  );
}

export default Card;
